import axios from "axios";

import { baseUrl } from "./baseUrl";

const api = axios.create({
    baseURL: `${baseUrl}/admin/quiz`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

export const createQuiz = async (data) => {
    try {
        const response = await api.post("/add-quiz", data);
        return response.data;
    } catch (error) {
        console.error("Error creating quiz:", error);
        throw error;
    }
}

export const getQuizById = async (id) => {
    try {
        const response = await api.get(`/view-quiz?id=${id}`);
        return response.data.quiz;
    } catch (error) {
        console.error("Error fetching quiz by ID:", error);
        throw error;
    }
}

export const updateQuiz = async (data) => {
    try {
        const response = await api.put(`/update-quiz`, data);
        return response.data;
    } catch (error) {
        console.error("Error updating quiz:", error);
        throw error;
    }
}

export const getQuizzes = async () => {
    try {
        const response = await api.get("/list-quiz");
        return response.data.quizzes;
    } catch (error) {
        console.error("Error fetching quizzes:", error);
        throw error;
    }
}

export const deleteQuiz = async (id) => {
    try {
        const response = await api.delete(`/delete-quiz?id=${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting quiz:", error);
        throw error;
    }
}

export const getUserQuizSubmissions = async (quizId) => {
    try {
        const response = await api.get(`/quiz-user-submissions?quizId=${quizId}`);
        return response.data.submissions || [];
    } catch (error) {
        console.error("Error fetching quiz submissions:", error);
        throw error;
    }
}